// Title + subtitle inputs for the "Stay in the loop" newsletter card —
// shared by the agency and agent proptree settings pages. Renders two
// full-width cells meant to sit inside the caller's 12-column grid.
// Blank input saves as null, which the public card renders as the
// default copy (shown here as the placeholder).
import {
  NEWSLETTER_DEFAULT_SUBTITLE,
  NEWSLETTER_DEFAULT_TITLE,
  NEWSLETTER_SUBTITLE_MAX,
  NEWSLETTER_TITLE_MAX,
} from '@proptr/shared';
import { Input } from './ui/input.js';
import { Label } from './ui/label.js';
import { cn } from '../lib/utils.js';

export function NewsletterCopyFields({
  idPrefix,
  title,
  subtitle,
  onTitleChange,
  onSubtitleChange,
}: {
  // Keeps label/input ids unique if two pages' fields ever co-exist.
  idPrefix: string;
  title: string;
  subtitle: string;
  onTitleChange: (v: string) => void;
  onSubtitleChange: (v: string) => void;
}) {
  return (
    <>
      <CopyField
        id={`${idPrefix}-title`}
        label="Title"
        value={title}
        onChange={onTitleChange}
        max={NEWSLETTER_TITLE_MAX}
        placeholder={NEWSLETTER_DEFAULT_TITLE}
      />
      <CopyField
        id={`${idPrefix}-subtitle`}
        label="Subtitle"
        value={subtitle}
        onChange={onSubtitleChange}
        max={NEWSLETTER_SUBTITLE_MAX}
        placeholder={NEWSLETTER_DEFAULT_SUBTITLE}
      />
    </>
  );
}

function CopyField({
  id,
  label,
  value,
  onChange,
  max,
  placeholder,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  max: number;
  placeholder: string;
}) {
  const remaining = max - value.length;
  return (
    <div className="col-span-12">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        className="mt-1"
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, max))}
        maxLength={max}
        placeholder={placeholder}
      />
      <div className="mt-1.5 flex items-center justify-between gap-3 font-mono text-[10px] leading-relaxed text-muted-foreground">
        <span>Leave blank to use the default.</span>
        <span
          className={cn(
            'shrink-0 tabular-nums',
            remaining <= 10 && 'text-amber-600',
          )}
        >
          {value.length}/{max}
        </span>
      </div>
    </div>
  );
}
